import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)

export const getDateFromNow = (timestamp: number): string => {
  if (!timestamp) return ''
  return dayjs(timestamp).fromNow()
}

export enum FormatDate {
  Short = 'DD/MM/YYYY',
  Long = 'DD MMMM YYYY',
  LT = 'LT',
  ll = 'll',
  lll = 'lll',
}

export const formatDate = (
  timestamp: number,
  format = FormatDate.Short
): string => {
  if (!timestamp) return ''
  if (Object.values(FormatDate).includes(format)) {
    const d = new Date(timestamp)
    return dayjs(d).format(format)
  }
  // Place more formats here
  //
  return ''
}
